import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { koKR, enUS, jaJP, deDE, zhCN, zhHK } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/ko';
import 'dayjs/locale/ja';
import 'dayjs/locale/de';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import { DEFAULT_LOCALE_CODE } from '../../constants';

/** LOCALE의 code와 1:1 대응. MUI DatePicker용 adapter·localeText (dayjs locale id는 zh-cn/zh-tw) */
const LOCALE_MAP = {
    ko: { adapter: 'ko', localeText: koKR.components.MuiLocalizationProvider.defaultProps.localeText },
    en: { adapter: 'en', localeText: enUS.components.MuiLocalizationProvider.defaultProps.localeText },
    ja: { adapter: 'ja', localeText: jaJP.components.MuiLocalizationProvider.defaultProps.localeText },
    de: { adapter: 'de', localeText: deDE.components.MuiLocalizationProvider.defaultProps.localeText },
    'zh-Hans': { adapter: 'zh-cn', localeText: zhCN.components.MuiLocalizationProvider.defaultProps.localeText },
    'zh-Hant': { adapter: 'zh-tw', localeText: zhHK.components.MuiLocalizationProvider.defaultProps.localeText },
};

/**
 * 앱 언어(i18n)에 맞춘 DatePicker 로케일 제공.
 * 캘린더 팝업 UI(요일명, 월명, 버튼 라벨 등)가 앱에서 선택한 언어로 표시되도록 함.
 */
export default function DatePickerLocaleProvider({ children }) {
    const { i18n } = useTranslation();
    const { adapterLocale, localeText } = useMemo(() => {
        const key = LOCALE_MAP[i18n.language] ? i18n.language : DEFAULT_LOCALE_CODE;
        const entry = LOCALE_MAP[key] ?? LOCALE_MAP[DEFAULT_LOCALE_CODE];
        return { adapterLocale: entry.adapter, localeText: entry.localeText };
    }, [i18n.language]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale} localeText={localeText}>
            {children}
        </LocalizationProvider>
    );
}
